import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SeatAssignmentModel } from '@shared/models/data/seat-assignment-model';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SessionService } from '@shared/services/session.service';
import { UserProfileService } from '@shared/services/user-profile.service';

@Component({
  selector: 'aaos-app-resident-curriculum-table',
  templateUrl: './resident-curriculum-table.component.html',
  styleUrls: ['./resident-curriculum-table.component.scss']
})
export class ResidentCurriculumTableComponent implements AfterViewInit {

  @ViewChild(MatSort) sort: MatSort;

  @Input() residentCurrSeats: SeatAssignmentModel[];

  dataSource: MatTableDataSource<SeatAssignmentModel>;
  columnsToDisplay = ['residencyPostGraduateYear', 'firstName', 'lastName', 'email', 'id', 'residencyDates', 'npi', 'registered'];
  selectedYear: string;
  institutionId: string;
  productId: string;
  loading = true;

  constructor(private sessionService: SessionService,
    private enrollmentService: EnrollmentService,
    private userProfileService: UserProfileService
    ) {
      this.dataSource = new MatTableDataSource();
    }

  ngAfterViewInit() {
    this.institutionId = this.sessionService.getInstitutionId();
    this.dataSource.sort = this.sort;
    this.enrollmentService.getOverViewModel(this.institutionId).subscribe(overviewModel => {
      this.productId = this.userProfileService.getResidentCurriculum(overviewModel).id;
      this.enrollmentService.getProductInstance(this.institutionId, this.productId).subscribe(product => {
        this.residentCurrSeats = product.seatAssignments;
        this.dataSource.data = this.residentCurrSeats;
        this.loading = false;
      });
    });
  }

  applyFilter(event) {
    const filterValue = this.selectedYear;
    this.dataSource.filterPredicate = (data: SeatAssignmentModel, filter: string) =>
      !filter || data.residencyPostGraduateYear.toString() === this.selectedYear.toString();
    this.dataSource.filter = filterValue;

  }

  trimLeadingZeros(stringToReplace: string) {
    return stringToReplace.replace(/^0+/, '');
  }
}
